<template>
  <v-tooltip bottom :disabled="!locked"  :nudge-top="10">
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <!-- Classe sem acesso NAO usa `:disabled`: o card precisa continuar
             recebendo o clique, que e o que abre o request a demo. -->
        <v-card
          color="black"
          @click="$emit('select', title)"
          :style="{ border: locked ? 'none' : '1px solid #febd0b !important', cursor: 'pointer' }"
          class="pa-2 rounded-lg"
        >
          <div class="d-flex pt-3 flex-gap-4 flex-row justify-center">
            <v-checkbox
              inset
              disabled
              class="ml-4"
              :input-value="!locked"
              color="orange"
            ></v-checkbox>
            <div
              style="width: 100%"
              class="d-flex flex-column align-start justify-start"
            >
              <span class="label-bold">{{ title }}</span>
            </div>
          </div>
        </v-card>
      </div>
    </template>
    <span>{{ $t('extras.noAccess') }}</span>
  </v-tooltip>
</template>
<script>
export default {
  props: ["title", "id", "locked"],
};
</script>
<style scoped>

.label-bold {
  /* Tracking em `em`, não `rem`: em rem ele é absoluto e não acompanha a fonte,
     então subir o título de 20 para 24px deixou o espaçamento parado em 1,6px
     (6,7% do corpo, ~9x o de um .text-h5 do Vuetify) e o texto esticado.
     0.02em mantém um respiro da marca e escala junto se o corpo mudar.
     BaseBadge e BaseAssetClass ficam lado a lado na /home e compartilham esta
     tipografia de propósito - mudar um exige mudar o outro. */
  /* Teto em 24px (o tamanho escolhido para desktop) e piso em 17px. Passou a
     importar quando os cards viraram 2-up ja no sm: a 600px cada coluna tem
     ~276px e o titulo fixo em 24px comia a linha inteira. */
  font-size: clamp(17px, 1.1vw + 9px, 24px) !important;
  letter-spacing: 0.02em;
  font-weight: 700 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .v-input {
  margin: 0;
}
</style>
